import { useContext } from 'react';
import { SyncContext, SyncContextValue } from './SyncContext';

export function useSyncStatus(): SyncContextValue {
  const context = useContext(SyncContext);

  if (!context) {
    throw new Error('useSyncStatus must be used within a SyncProvider');
  }

  return context;
}

/**
 * The same context, or null outside a SyncProvider. For surfaces that are
 * mounted with or without the provider (the shared UnsentCard on Today and
 * the Forms hub): they read the outbox from Dexie directly and only use the
 * provider, when it is there, to kick a drain.
 */
export function useOptionalSyncStatus(): SyncContextValue | null {
  return useContext(SyncContext);
}
